import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

// Connect to Firebase Auth Emulator in offline/on-premise mode
if (process.env.VUE_APP_FIREBASE_AUTH_EMULATOR_URL) {
  connectAuthEmulator(auth, process.env.VUE_APP_FIREBASE_AUTH_EMULATOR_URL, { disableWarnings: true });
  console.log('[Firebase] Connected to Auth Emulator:', process.env.VUE_APP_FIREBASE_AUTH_EMULATOR_URL);
}

export { auth, firebaseApp };
